import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import JobDetailsSkeleton from "@/pages/_layouts/jobs/_components/JobDetailsSkeleton";
import JobDetailsTabContent from "@/pages/_layouts/jobs/_components/JobDetailsTabContent";
import { useRecentlyVisited } from "@/hooks/useRecentlyVisited";
import { useEffect } from "react";

export default function JobPostDetails() {
  const location = useLocation();
  const { data, loading, title } = useOutletContext<JobsOutletContext>();
  const { addRecentlyVisitedItem } = useRecentlyVisited();

  useEffect(() => {
    if (data?.jobPost) {
      addRecentlyVisitedItem({
        url: window.location.pathname,
        text: data.jobPost.name,
        subtext: data.jobPost.facility?.name || "",
        image: "business_center",
        type: "jobs"
      });
    }
  }, [data, addRecentlyVisitedItem]);

  if (loading) {
    return <JobDetailsSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Details`} />
      <JobDetailsTabContent jobPost={data.jobPost} />
    </>
  );
}
